import { render, staticRenderFns } from "./SocialRewardsItem.vue?vue&type=template&id=30ed9326&scoped=true&"
import script from "./SocialRewardsItem.vue?vue&type=script&lang=ts&"
export * from "./SocialRewardsItem.vue?vue&type=script&lang=ts&"
import style0 from "./SocialRewardsItem.vue?vue&type=style&index=0&id=30ed9326&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ed9326",
  null
  
)

export default component.exports